import { getSingleton, registerSingleton } from 'fe-lib-singleton'
import rawAxios from 'axios'

export default getSingleton('axios') || registerSingleton('axios', rawAxios)